import { BaSeButton, BaSeTheme, BaSeTooltip } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';
import { useModule } from '../../../../../../hooks/module/module';
import { BoxTag } from '../../../../components/data-table/data-table-styled';

function ButtonAcessInterview({
  color,
  name,
  idModulo,
  cpf,
  handleCpfSearched,
  closeModal,
}) {
  const { navigateTo } = Sebrae.useRouter();

  const { moduleSelected } = useModule();

  const [tooltipOpen, setTooltipOpen] = React.useState(false);
  const getUrl = React.useCallback(() => {
    const url = window.location.protocol + '//' + window.location.host;
    return url;
  }, []);

  const handleClich = React.useCallback(() => {
    if (moduleSelected?.id === idModulo) {
      closeModal('close');
      handleCpfSearched(cpf);
      return;
    }

    navigateTo(`${getUrl()}/gestor/entrevista?modulo=${idModulo}`, {
      forceReload: false,
    });
    handleCpfSearched(cpf);
  }, [
    idModulo,
    moduleSelected,
    navigateTo,
    getUrl,
    handleCpfSearched,
    cpf,
    closeModal,
  ]);
  return (
    <>
      <BoxTag
        onMouseEnter={() => setTooltipOpen(true)}
        onMouseLeave={() => setTooltipOpen(false)}
      >
        <BaSeButton
          type="tertiary"
          onClick={handleClich}
          color={color}
          value={name}
        />
        <BaSeTooltip
          color={BaSeTheme.colors.institucionais.cinzaSebrae60}
          direction="top"
          coordinates={{ top: '-34px' }}
          message={'Acessar entrevista'}
          messageNoBreakLine
          open={tooltipOpen}
        />
      </BoxTag>
    </>
  );
}

export default ButtonAcessInterview;
